import { FC } from 'react'
import { Button, Text, Table } from '@/ui'
import { archiveTransactionRule } from '@/actions/admin/transactionRuleActions'
import { ArchiveReason } from '@/constants/transactionRuleConstants'
import { UserWithAdminInfo } from '@/reducers/admin/allUsersReducer'
import { selectTransactionRulesById } from '@/features/transactions/transactions.selectors'
import { getAllTransactionCategories } from '@/features/reports/reports.selectors'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles } from '@/styles'

interface props {
  user: UserWithAdminInfo
}
export const UserTransactionRulesTable: FC<props> = ({ user }) => {
  const dispatch = useAppDispatch()
  const allTransactionRules = useReselector(selectTransactionRulesById)
  const categories = useReselector(getAllTransactionCategories)

  const userTransactionRules = Object.values(allTransactionRules).filter(
    (rule) => rule.userId === user.id && !rule.archivedAt
  )

  const archiveRule = async (ruleId: number) => {
    await archiveTransactionRule(ruleId, {
      reason: ArchiveReason.USER_REQUEST,
    })(dispatch)
  }
  return (
    <div>
      <Text variant={TypographyStyles.LABEL_MD} className="mb-2">
        {userTransactionRules.length} transaction rules
      </Text>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>ID</Table.HeaderCell>
            <Table.HeaderCell>Rule Use</Table.HeaderCell>
            <Table.HeaderCell>Rule Text</Table.HeaderCell>
            <Table.HeaderCell>Rule Type</Table.HeaderCell>
            <Table.HeaderCell>Category Type</Table.HeaderCell>
            <Table.HeaderCell>Category Name</Table.HeaderCell>
            <Table.HeaderCell>Category Id</Table.HeaderCell>
            <Table.HeaderCell>For Amount</Table.HeaderCell>
            <Table.HeaderCell>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {userTransactionRules.map((rule, i) => {
            const categoryName =
              rule.transactionCategoryId &&
              categories?.[rule.transactionCategoryId]?.name

            return (
              <Table.Row key={i}>
                <Table.Cell>{rule.id}</Table.Cell>
                <Table.Cell>{rule.ruleUse}</Table.Cell>
                <Table.Cell>{rule.ruleText}</Table.Cell>
                <Table.Cell>{rule.ruleType}</Table.Cell>
                <Table.Cell>{rule.transactionCategoryType}</Table.Cell>
                <Table.Cell>{categoryName}</Table.Cell>
                <Table.Cell>{rule.transactionCategoryId}</Table.Cell>
                <Table.Cell>{rule.amountInCents}</Table.Cell>
                <Table.Cell>
                  <Button
                    variant="secondary"
                    onClick={() => archiveRule(rule.id)}
                  >
                    Archive Rule
                  </Button>
                </Table.Cell>
              </Table.Row>
            )
          })}
        </Table.Body>
      </Table>
    </div>
  )
}
